button.remove{padding:0;background-color:transparent;border:0;color:#fff;font-weight:700;opacity:50%;outline:none}button.remove:disabled:hover{opacity:50%}button.remove:hover{opacity:85%}
/*# sourceMappingURL=tags.component-GSRTU7PH.css.map */
